export enum Certificates {
  'KWT' = 'KWT',
  'DC' = 'DC'
}
